import styled from 'styled-components';
import { useTemplateContext } from 'modules/campaigns/editor/context';
import { EmbeddedPrimaryContent } from 'modules/campaigns/editor/types';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { LightText, StyledNewTabLink } from '../Sections.styled';

const MediaUrlWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7.5px;
`;

export const EmbeddedContent = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent = {} } = templateAndContent;
  const { title, body, elements } = primaryContent as EmbeddedPrimaryContent;
  const mediaUrl = elements?.mediaUrl;
  return (
    <>
      <CampaignFormField labelText="Title">
        <ReadOnlyField name="title">{title || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Body">
        <ReadOnlyField name="body">{body || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Media URL">
        <ReadOnlyField name="mediaUrl">
          {mediaUrl ? (
            <MediaUrlWrapper>
              <StyledNewTabLink href={mediaUrl}>{mediaUrl}</StyledNewTabLink>
            </MediaUrlWrapper>
          ) : (
            <LightText>Not set</LightText>
          )}
        </ReadOnlyField>
      </CampaignFormField>
    </>
  );
};
